const ALLOWED_LICENSES = new Set([
  'CC0-1.0',
  'OFL-1.1',
  'Unlicense',
  'Apache-2.0',
  'MIT',
  'CC-BY-3.0',
  'CC-BY-4.0',
  'ISC',
  'BSD-3-Clause',
  'MPL-2.0',
]); // List of icon licenses

// Whether an Iconify icon set (its metadata: the IconifyInfo type of @iconify/types) is
// under one of the allowed licences, by the licence's SPDX id; a licence without one, which
// the type allows, counts as not allowed, and so does a set without a licence, which it
// doesn't. The icon editor's library and the credits page filter the sets with it
export const hasAllowedLicence = (info) =>
  ALLOWED_LICENSES.has(info.license?.spdx);

export const LICENCE_CATALOGUE = {
  'Apache-2.0': {
    file: 'Apache-2.0.txt',
    title: 'Apache License 2.0',
  },
  MIT: {
    file: 'MIT.txt',
    title: 'MIT License',
  },
  ISC: {
    file: 'ISC.txt',
    title: 'ISC License',
  },
  'BSD-3-Clause': {
    file: 'BSD-3-Clause.txt',
    title: 'BSD 3-Clause License',
  },
  'MPL-2.0': {
    file: 'MPL-2.0.txt',
    title: 'Mozilla Public License 2.0',
  },
  'OFL-1.1': {
    file: 'OFL-1.1.txt',
    title: 'Open Font License 1.1',
  },
  'CC0-1.0': {
    file: 'CC0-1.0.txt',
    title: 'Creative Commons Zero 1.0',
  },
  Unlicense: {
    file: 'Unlicense.txt',
    title: 'The Unlicense',
  },
  'CC-BY-3.0': {
    file: 'CC-BY-3.0.txt',
    title: 'Creative Commons Attribution 3.0',
  },
  'CC-BY-4.0': {
    file: 'CC-BY-4.0.txt',
    title: 'Creative Commons Attribution 4.0',
  },
};
